interface Props {
  number: string;
  description: string;
  client: string;
  status: string;
  time: string;
  target: string;
  priority: string;
  line: string;
  caller: string;
  operator: string;
}

const Incident = ({
  number,
  description,
  client,
  status,
  time,
  target,
  priority,
  line,
  caller,
  operator,
}: Props) => {
  const isTargetPastOrToday = (targetDate: string) => {
    const [day, month, year] = targetDate.split("-").map(Number);
    const targetDateObj = new Date(year, month - 1, day);
    const today = new Date();

    targetDateObj.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return targetDateObj < today;
  };

  // Change line
  let whatline = "FL";
  if (line === "secondLine") {
    whatline = "SL";
  }

  const containerClass = isTargetPastOrToday(target)
    ? "w-full text-red-500 border-b-2 border-gray-300 flex p-2 flex items-center text-sm hover:bg-gray-50"
    : priority === "P1"
    ? "w-full text-black bg-red-500 border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50"
    : "w-full text-black border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50";
  return (
    <div className={containerClass}>
      <p className="w-1/12">{number}</p>
      <p className="w-2/12">{description}</p>
      <p className="w-2/12 text-left">{client}</p>
      <p className="w-2/12 text-left">{status}</p>
      <div className="w-2/12 flex flex-col text-nowrap justify-center">
        <p>
          <b>Target:</b> {target}
        </p>
        <p>
          <b>Tijd:</b> {time}
        </p>
        <p>
          <b>Prioritijd:</b> {priority}
        </p>
        <p>
          <b>Lijn:</b> {whatline}
        </p>
      </div>
      <div className="w-2/12 flex flex-col text-nowrap justify-center">
        <p>
          <b>Aanvrager:</b> {caller}
        </p>
        <p>
          <b>Operator:</b> {operator}
        </p>
      </div>
    </div>
  );
};

export default Incident;
